import { useState, useEffect } from "react";
import {
  fetchDrones,
  addDroneApi,
  deleteDroneApi,
  updateDroneApi
} from "../api/droneApi";

export default function useDrones(token) {
  const [drones, setDrones] = useState([]);
  const [activeDroneId, setActiveDroneId] = useState(null);

  // Load drones on mount
useEffect(() => {
  if (!token) return;

  fetchDrones(token).then(data => {
    console.log("FETCHED DRONES:", data);
    console.log("TYPE:", typeof data);

    // Normalize to avoid crashes
    const list = Array.isArray(data)
      ? data
      : Array.isArray(data?.drones)
        ? data.drones
        : [];

    setDrones(list);

    if (list.length > 0) {
      setActiveDroneId(list[0].id || list[0].drone_id);
    }
  });
}, [token]);


  // Add drone (UI + API + refresh)
  const addDrone = async () => {
    const name = prompt("Enter Drone Name:");
    if (!name) return;

    const id = `drone-${Date.now()}-${Math.floor(Math.random() * 1000)}`;

    const result = await addDroneApi(token, name, id);
    if (result?.success) {
      const updated = await fetchDrones(token);
      setDrones(updated);
    }
  };

  // Delete drone (API + refresh)
  const deleteDrone = async (id) => {
    await deleteDroneApi(token, id);
    const updated = await fetchDrones(token);
    setDrones(updated);

    if (activeDroneId === id) setActiveDroneId(null);
  };

  // Update drone (API + local state)
  const updateDrone = async (id, route, telemetry) => {
    setDrones(prev =>
      prev.map(d => d.id === id ? { ...d, route, telemetry } : d)
    );

    await updateDroneApi(token, id, route, telemetry);
  };

  const activeDrone = drones.find(d => d.id === activeDroneId);

  return {
    drones,
    activeDrone,
    activeDroneId,
    setActiveDroneId,
    addDrone,
    deleteDrone,
    updateDrone,
    setDrones
  };
}
